// Message Origin
const origin = "*";

interface SymbolicLayerMessageData {
    label: string;
    url: string;
};

interface ProgramLayerMessageData {
    id: number;
    name: string;
}

// Handle view event
export const updateDashboard = (visible: boolean) => {
    window.parent.postMessage(
        {
            message: "updateDashboard",
            data: { visible }
        },
        origin
    );
    console.log(`Dashboard visibility updated: ${visible}`);
};

export const toggleProgrammaticLayer = (programData: ProgramLayerMessageData[]) => {
    window.parent.postMessage(
        {
            message: "toggleProgrammaticLayer",
            data: programData
        },
        origin
    );
    console.log("Toggle programmatic layer message sent:", { programData });
};

export const toggleSymbolicLayer = (layerData: SymbolicLayerMessageData[]) => {
    window.parent.postMessage(
        {
            message: "toggleSymbolicLayer",
            data: layerData
        },
        origin
    );
    console.log("Toggle symbolic layer message sent:", { layerData });
}

export const toggleOverlayLayer = (id: number, name: string) => {
    window.parent.postMessage(
        {
            message: "toggleOverlayLayer",
            data: {
                id,
                name
            }
        },
        origin
    );
    console.log("Toggle index map layer message sent:", { id, name });
}

// Send message to clear map selection
export const handleClearSelection = () => {
    window.parent.postMessage(
        {
            message: "clearMapSelection",
        },
        origin
    );
    console.log("Clear map selection message sent.");
}

export const clearAllLayers = () => {
    // Send message to clear map layer overlay, programmatic layer, and symbolic layer selection
    window.parent.postMessage(
        {
            message: "clearOverlayLayers",
        },
        origin
    );
    console.log("Clear map overlay layers message sent.");

    window.parent.postMessage(
        {
            message: "clearProgrammaticLayers",
        },
        origin
    );
    console.log("Clear map programmatic layers message sent.");

    window.parent.postMessage(
        {
            message: "clearSymbolicLayers",
        },
        origin
    );
    console.log("Clear map symbolic layers message sent.");
}

export const clearSymbolicLayers = () => {
    window.parent.postMessage(
        {
            message: "clearSymbolicLayers"
        },
        origin
    );
    console.log("Clear map symbolic layers message sent.");
};

export const clearProgrammaticLayers = () => {
    window.parent.postMessage(
        {
            message: "clearProgrammaticLayers"
        },
        origin
    );
    console.log("Clear programmatic layers message sent.")
};

export const handleRestoreDefaultView = () => {
  window.parent.postMessage(
    { message: "restoreDefaultView" },
    origin
  );
  console.log("restoreDefaultView message sent.");
};

export const handleCloseStorymap = () => {
  window.parent.postMessage(
    { message: "closeStorymap" },
    origin
  );
  console.log("closeStorymap message sent.");
};

export const showProgramPoint = (item?: { id: number; lat: number; long: number }) => {
  if (!item) return;

  window.parent.postMessage(
    {
      message: "showProgram",
      data: {
        id: item.id,
        latitude: item.lat,
        longitude: item.long,
      },
    },
    origin
  );
  console.log("program point message sent.");
};